import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './shared/layout/layout.component';
import { ConfirmUserComponent } from './feature/confirm-user/confirm-user.component';


const routes: Routes = [
  {
    path: '',
    //loadChildren: () => import('./feature/maintenance/maintenance.component.module').then(m => m.MaintenanceModule)
    loadChildren: () => import('./feature/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./feature/register/register.component.module').then(m => m.RegisterModule)
  },
  {
    path: 'forgotpassword',
    loadChildren: () => import('./feature/forgotpassword/forgotpassword.component.module').then(m => m.ForgotpasswordModule)
  },
  {
    path: 'userverification',
    loadChildren: () => import('./feature/userverification/userverification.component.module').then(m => m.UserverificationModule)
  },
  {
    path: 'confirm-user', component: ConfirmUserComponent
  },
  {
    path: '',
    component: LayoutComponent,
    /* canActivate:[AuthGuard], */
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./feature/dashboard/dashboard.component.module').then(m => m.DashboardModule)
      },

      {
        path: 'searchproduct',
        loadChildren: () => import('./feature/searchproduct/searchproduct.component.module').then(m => m.SearchproductModule)
      },

      {
        path: 'productdetail',
        loadChildren: () => import('./feature/productdetail/productdetail.component.module').then(m => m.ProductdetailModule)
      },

      {
        path: 'shoppingcart',
        loadChildren: () => import('./feature/shoppingcart/shoppingcart.component.module').then(m => m.ShoppingcartModule)
      },

      {
        path: 'whishlist',
        loadChildren: () => import('./feature/whishlist/whishlist.component.module').then(m => m.WhishlistModule)
      },

      {
        path: 'orderdetail',
        loadChildren: () => import('./feature/orderdetail/orderdetail.component.module').then(m => m.OrderdetailModule)
      },

      {
        path: 'shoppingcartsummary',
        loadChildren: () => import('./feature/shoppingcartsummary/shoppingcartsummary.component.module').then(m => m.ShoppingcartsummaryModule)
      },
      {
        path: 'orderlist',
        loadChildren: () => import('./feature/orderlist/orderlist.component.module').then(m => m.OrderlistModule)
      },
      {
        path: 'shoppingcartdetail',
        loadChildren: () => import('./feature/shoppingcartdetail/shoppingcartdetail.component.module').then(m => m.ShoppingcartdetailModule)
      },
      {
        path: 'setting',
        loadChildren: () => import('./feature/setting/setting.component.module').then(m => m.SettingModule)
      },

      {
        path: 'userregister',
        loadChildren: () => import('./feature/userregister/userregister.component.module').then(m => m.UserregisterModule)
      },

      {
        path: 'account',
        loadChildren: () => import('./feature/account/account.component.module').then(m => m.AccountModule)
      },

      {
        path: 'contactus',
        loadChildren: () => import('./feature/contact-us/contact-us.component.module').then(m => m.ContactUsModule)
      },
      {
        path: 'modelvc',
        loadChildren: () => import('./feature/modelvc/modelvc.component.module').then(m => m.ModelVCModule)
      },
      {
        path: 'modelvilax',
        loadChildren: () => import('./feature/modelvilax/modelvilax.component.module').then(m => m.ModelVilaxModule)
      },
      {
        path: 'modeldvh',
        loadChildren: () => import('./feature/modeldvh/modeldvh.component.module').then(m => m.ModelDvhModule)
      },
      {
        path: 'modelprefa',
        loadChildren: () => import('./feature/modelprefa/modelprefa.component.module').then(m => m.ModelPrefaModule)
      },
      {
        path: 'modelprefasinreglas',
        loadChildren: () => import('./feature/modelprefasinreglas/modelprefasinreglas.component.module').then(m => m.ModelprefasinreglasModule)
      },
      {
        path: 'confirmmodel',
        loadChildren: () => import('./feature/confirm-model/confirm-model.component.module').then(m => m.ConfirmModelModule)
      },
      {
        path: 'bomlist',
        loadChildren: () => import('./feature/bomlist/bomlist.component.module').then(m => m.BomlistModule)
      },
      {
        path: 'warninglist',
        loadChildren: () => import('./feature/warning-list/warning-list.component.module').then(m => m.WarninglistModule)
      },
      {
        path: 'graphicmodel',
        loadChildren: () => import('./feature/graphic-model/graphic-model.component.module').then(m => m.GraphicModelModule)
      }
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
